import { createSlice } from '@reduxjs/toolkit';
import { getLoyaltyPointDashboard, exportUserLoyaltyPointDashboard } from './actions';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const loyaltyPointDashboard = createSlice({
  name: 'loyaltyPointDashboard',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLoyaltyPointDashboard.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getLoyaltyPointDashboard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getLoyaltyPointDashboard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(exportUserLoyaltyPointDashboard.pending, (state) => {
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(exportUserLoyaltyPointDashboard.rejected, (state, action) => {
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(exportUserLoyaltyPointDashboard.fulfilled, (state) => {
        state.isError = false;
      });
  },
});

export default loyaltyPointDashboard.reducer;
